
(function () {
    document.addEventListener('click', function (e) {
      const toggle = e.target.closest('[data-loc-toggle]');
      const moreBtn = e.target.closest('[data-loc-more]');
      const item = e.target.closest('.loc-item');

      if (toggle) {
        const id = toggle.getAttribute('data-loc-toggle');
        const menu = document.getElementById(id);
        if (menu) {
          const hidden = menu.hasAttribute('hidden');
          document.querySelectorAll('.loc-menu').forEach((m) => m.setAttribute('hidden', ''));
          if (hidden) menu.removeAttribute('hidden');
        }
        return;
      }

      if (moreBtn) {
        const id = moreBtn.getAttribute('data-loc-more');
        const more = document.getElementById(id);
        if (more) {
          const hidden = more.hasAttribute('hidden');
          if (hidden) {
            more.removeAttribute('hidden');
            moreBtn.textContent = moreBtn.textContent.replace('▾', '▴');
          } else {
            more.setAttribute('hidden', '');
            moreBtn.textContent = moreBtn.textContent.replace('▴', '▾');
          }
        }
        return;
      }

      if (item) {
        const wrap = item.closest('.loc-wrap');
        const form = wrap?.closest('form');
        const kind = item.getAttribute('data-loc-kind');
        const val = item.getAttribute('data-loc-value');

        if (kind === 'language') {
          form.querySelector('input[name="language_code"]').value = val;
          form.submit();
        } else if (kind === 'country') {
          form.querySelector('input[name="country_code"]').value = val;
          form.submit();
        }
      } else if (!e.target.closest('.loc-wrap')) {
        document.querySelectorAll('.loc-menu').forEach((m) => m.setAttribute('hidden', ''));
      }
    });
  })();